import Website from './Website';
export default Website;
export { default as getData } from './getData';